<template>
  <div>
    Selecting this option displays the target relative distance to its nominal
    orbit considering the evasive maneuvers.

    <br />
    <br />

    This option allows the user to have a better understanding of the performed
    maneuvers in terms of its service for example.
  </div>
</template>

<script>
export default {
  name: 'tooltipTargetDistanceToNominalDisplayOption'
}
</script>
